// Quién retiene el teléfono al abrir o retomar una venta, y qué se le dice al vendedor.
import { ApiError } from '@/api/errors';
import type { WizardSession } from './types';

export const OTHER_STORE_SALE_MESSAGE = 'Este cliente tiene una venta en curso en otra sucursal';
export const OTHER_STORE_SALE_HINT =
    'El encargado de la tienda puede cancelarla para que la venta se haga aquí.';
export const TAKEN_OVER_MESSAGE = 'Otra sucursal tomó a este cliente';
export const TAKEN_OVER_HINT =
    'Esta venta se canceló porque otra sucursal empezó una venta con el mismo cliente.';

/** `SAME_STORE` trae la venta de esta tienda para continuarla; `OTHER_STORE` no expone la ajena. */
export type PhoneHolderConflict =
    | { kind: 'SAME_STORE'; sessionId: string }
    | { kind: 'OTHER_STORE' };

function sessionIdOf(data: unknown): string | undefined {
    if (typeof data !== 'object' || data === null) return undefined;
    const sessionId = (data as { sessionId?: unknown }).sessionId;
    return typeof sessionId === 'string' && sessionId !== '' ? sessionId : undefined;
}

/** El 409 de abrir o reabrir porque el teléfono ya tiene venta; `null` si es otro error. */
export function phoneHolderConflictOf(error: unknown): PhoneHolderConflict | null {
    if (!(error instanceof ApiError)) return null;
    if (error.code === 'SESSION_ACTIVE_OTHER_STORE') return { kind: 'OTHER_STORE' };
    if (error.code !== 'SESSION_ACTIVE') return null;
    const sessionId = sessionIdOf(error.data);
    return sessionId ? { kind: 'SAME_STORE', sessionId } : { kind: 'OTHER_STORE' };
}

/** La venta ya no está abierta (409 INVALID_SESSION_STATE). */
export function isSessionNotOpen(error: unknown): boolean {
    return error instanceof ApiError && error.code === 'INVALID_SESSION_STATE';
}

/** La venta se canceló porque otra sucursal tomó al cliente. */
export function isTakenOverByOtherStore(
    session: Pick<WizardSession, 'state' | 'takenOverByOtherStore'> | undefined,
): boolean {
    return session?.state === 'CANCELLED' && session.takenOverByOtherStore === true;
}
